import React from "react";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

import { ReactComponent as Facebook } from "./../Global/Icons/facebook.svg";
import { ReactComponent as Twitter } from "./../Global/Icons/twitter.svg";

const multiple = nota.global.multiple;

const StyledSocialIconsCard = styled.div`
  width: 100%;
  padding: ${multiple / 2 + "px"} 0; /* 4px */
  .socialWrapper {
    width: auto;
    margin: 0 ${multiple * 3 + "px"};
    a {
      display: contents;
      cursor: pointer;
      text-decoration: none;
      svg {
        path {
          fill: ${nota.color.neutral.NeuOne};
        }
      }
      p {
        margin-left: ${multiple / 2 + "px"}; /*4px*/
      }
    }
  }
`;

const SocialIconsCard = (props) => {
  return (
    <StyledSocialIconsCard>
      <NanoFlex justifyContent={"flex-end"} >
        {props.facebookPage && (
          <NanoFlex className="socialWrapper" >
            <a href={props.facebookPage} target="_blank">
              <Facebook />
              <Type.p>{props.followsFacebook}</Type.p>
            </a>
          </NanoFlex>
        )}
        {props.twitterPage && (
          <NanoFlex className="socialWrapper" >
            <a href={props.twitterPage} target="_blank">
              <Twitter />
              <Type.p>{props.followsTwitter}</Type.p>
            </a>
          </NanoFlex>
        )}
      </NanoFlex>
    </StyledSocialIconsCard>
  );
};

// Set default props
SocialIconsCard.defaultProps = {
  followsFacebook: "", // 'Follows Faceboo'
  followsTwitter: "", // 'Follows Twitter'
};

export default SocialIconsCard;

// --- // Documentation // --- //
/*
import CardBlock from './../Nano/SourceProgrammeCard.js';

<SocialIconsCard
    followsFacebook={'Follows Facebook'}
    followsTwitter={'Follows Twitter'}
/>
*/
